export default class {
  constructor($uibModalInstance) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
  }
  ok() {
    this.$uibModalInstance.close();
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}
